import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { Vehicle } from '../../models/Vehicle';
import { makeVehicleApiRequest } from '../MakeVehicleApiRequestService/MakeVehicleApiRequestService';

export function validateVin(vin: string, vehicleManufacturerCodes: string): boolean {
	// First 3 chars must match VW codes (e.g. WVW | WV1 | WV2, …),
	// then 14 alphanumeric chars excluding I, O & Q
	const pattern = `^${vehicleManufacturerCodes}[A-HJ-NPR-Z0-9]{14}$`;
	return new RegExp(pattern, 'i').test(vin);
}

export async function getVehicleDetails(
	authService: IAuthServiceV2,
	resourceHostId: string,
	vinNo: string,
	language: string,
	url: string,
	bid: string,
	countryCode: string,
	apiKey: string,
	vinToken?: string,
): Promise<Vehicle> {
	return makeVehicleApiRequest<Vehicle>({
		authService,
		resourceHostId,
		url,
		endpoint: 'api/vehicleData',
		apiKey,
		vinToken,
		body: {
			vin: vinNo.toUpperCase(),
			languageCode: language,
			bid,
			countryCode,
			extendedData: true,
		},
	});
}
